exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.div_border[data-v-0832cbb8] {\n  border: solid 1px;\n  border-radius: 5px;\n}\n/* div {\n  page-break-inside: avoid;\n  page-break-after: always;\n} */\n", ""]);

// exports
